import { AreaChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area } from 'recharts';
import { Container, NoDataContainer, NoDataText } from './styles';
import { CustonLoading } from '../../Components';
import { useTranslation } from "react-i18next";

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = (`0${date.getDate()}`).slice(-2);
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const hours = (`0${date.getHours()}`).slice(-2);
    const minutes = (`0${date.getMinutes()}`).slice(-2);
    return `${day}/${month} - ${hours}:${minutes}`;
};

const CustonGraph = ({ data, min, max }) => {

    const { t } = useTranslation();

    const mergedData = data.reduce((acc, serie) => {
        serie.data.forEach(point => {
            const existing = acc.find(item => new Date(item.x).getTime() === new Date(point.x).getTime());
            if (existing) {
                existing[serie.id] = point.y;
            } else {
                acc.push({ x: point.x, [serie.id]: point.y });
            }
        });
        return acc;
    }, []).sort((a, b) => new Date(a.x) - new Date(b.x));


    const findNearPoints = (time) => {
        let nearPoints = [];
        data.forEach((item) => {
            let minDiff = Infinity;
            let nearestPoint = null;

            item.data.forEach((subiten) => {
                const diff = Math.abs(subiten.x - time);
                // garanti que o ponto mais proximo esteja a pelo menos 10 minutos de distancia
                if (diff < minDiff && diff < 600000) {
                    minDiff = diff;
                    nearestPoint = subiten;
                    subiten.name = item.id;
                    subiten.color = item?.id?.includes('Setpoint') ? '#3C9' : '#4361EE';
                }
            });

            if (nearestPoint) {
                nearPoints.push(nearestPoint);
            }
        });
        return nearPoints;
    };

    // Custom tooltip for Recharts
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            const date = new Date(label);
            const day = (`0${date.getDate()}`).slice(-2);
            const month = (`0${date.getMonth() + 1}`).slice(-2);
            const hours = (`0${date.getHours()}`).slice(-2);
            const minutes = (`0${date.getMinutes()}`).slice(-2);
            const horario = `${day}/${month} - ${hours}:${minutes}`;

            let points = findNearPoints(label);
            
            return (
                <div style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: 10 }}>
                    <div style={{ color: '#333' }}><strong>Horário: </strong>{horario}</div>
                    {points.map((entry, index) => (
                        <div key={`item-${index}`} style={{ color: entry.color }}>
                            <strong>{entry.name}:</strong> {parseFloat(entry.y).toFixed(2)}
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };        

    return (
        <Container>
            {data[0]?.Loading ? (
                <CustonLoading size={80} />
            ) : data[0]?.data?.length > 0 ? (
                <ResponsiveContainer width="100%" height={400}>
                    <AreaChart
                        data={mergedData}
                        margin={{ top: 30, right: 50, bottom: 90, left: 60 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="x"
                            tickFormatter={formatDate}
                            minTickGap={20}
                            angle={60}
                            textAnchor="start"
                            height={80}
                        />
                        <YAxis
                            type="number"
                            domain={[
                                Number.isFinite(parseFloat(min)) ? parseFloat(min) : 'auto',
                                Number.isFinite(parseFloat(max)) ? parseFloat(max) : 'auto'
                            ]}
                            allowDataOverflow={true}
                        />
                        <Tooltip content={CustomTooltip} />
                        {data.map((serie, index) => (
                            <Line
                                key={index}
                                type={'linear'}
                                dataKey={serie.id}
                                stroke={data.length > 1 ? (index === 0 ? '#3C9' : '#4361EE') : '#4361EE'}
                                strokeWidth={2}
                                dot={{ r: 1 }}
                                activeDot={{ r: 3 }}
                                connectNulls
                                isAnimationActive={false}
                            />
                        ))}
                        {data.map((serie, index) => (
                            <Area
                                key={index}
                                type={'linear'}
                                dataKey={serie.id}
                                stroke={data.length > 1 ? (index === 0 ? '#3C9' : '#4361EE') : '#4361EE'}
                                fill={data.length > 1 ? (index === 0 ? '#3C9' : '#4361EE') : '#4361EE'}
                                fillOpacity={0.3}
                                isAnimationActive={false}
                            />
                        ))}
                    </AreaChart>
                </ResponsiveContainer>
            ) : (
                <NoDataContainer>
                    <NoDataText>{t("components.no-data")}</NoDataText>
                </NoDataContainer>
            )}
        </Container>
    );
};

export default CustonGraph;